import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import "./assets/css/global.css";
import "./assets/fonts/iconfont.css";
import TreeTable from "vue-table-with-tree-grid";
import VueQuillEditor from "vue-quill-editor";
import * as filters from "@/filters/index"; // filter 过滤器
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import "nprogress/nprogress.css";
import store from "./store/globalStore";
import lodash from "lodash";
import ElementUI from "element-ui";
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);

//引入过滤器
import "./assets/js/filter.js";
//引入axios请求
import "./assets/js/request.js";
//引入权限控制
import "./assets/js/auth.js";
//引入表格样式
import tableStyle from "./assets/js/tableStyleData.js";
import commonData from "./assets/js/commonData.js";
import ImageUpload from "@/components/ImageUpload";


Vue.component("tree-table", TreeTable);

//引入页面整体组件
import fullCon from "./views/FullContainer";
import tableCon from "./views/tableContainer";
import editBreadcrumb from "./views/layout/components/editBreadCrumb";
import Print from "vue-print-nb";
import modalDialog from "./components/ModalDialog/index";
import HxTable from '@/components/HxTable/index.vue'

Vue.component("full-con", fullCon);
Vue.component("table-con", tableCon);
Vue.component("editBreadcrumb", editBreadcrumb);
Vue.component('HxTable', HxTable)
Vue.component("ImageUpload", ImageUpload);

//自定义组件注册
import { setComponent } from "@/componentsMy"
setComponent(Vue)
// 全局注入过滤器filters
Object.keys(filters).forEach((key) => {
  Vue.filter(key, filters[key]);
});

Vue.use(Print);
Vue.use(VueQuillEditor);
Vue.use(modalDialog, { router, store });
Vue.prototype.tableStyle = tableStyle;
Vue.prototype.commonData = commonData;
Vue.prototype._ = lodash;
//防抖
const on = Vue.prototype.$on;
Vue.prototype.$on = function (event, func) {
  let timer;
  let flag = true;
  let newFunc = func;
  if (event == "click") {
    newFunc = function () {
      if (flag) {
        func.apply(this, arguments);
        flag = false;
      }
      clearTimeout(timer);
      timer = setTimeout(function () {
        flag = true;
      }, 500);
    };
  }
  on.call(this, event, newFunc);
};

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
